


















































































































































































import Vue, { PropType } from "vue";
import i18n from "@/lang";
import moment from "moment";
import { mapGetters } from "vuex";

// Model
import { GetMachineRejectsResData } from "@/model/communication/logAnalysis/GetMachineRejectsResData";
import { GetMachineRejectsCommand, GetMachineRejectsReqData } from "@/model/communication/logAnalysis/GetMachineRejectsCommand";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { GetProcessedCashCommand, GetProcessedCashReqData } from "@/model/communication/logAnalysis/GetProcessedCashCommand";
import { GetProcessedCashResData } from "@/model/communication/logAnalysis/GetProcessedCashResData";
import { Machine } from "@/model/data/Machine";
import { Reject } from "@/model/data/logAnalysis/Reject";
import { GetMachineExceptionsReqData, GetMachineExceptionsCommand } from "@/model/communication/logAnalysis/GetMachineExceptionsCommand";
import { GetMachineExceptionsResData } from "@/model/communication/logAnalysis/GetMachineExceptionsResData";
import { MachineException } from "@/model/data/logAnalysis/MachineException";
import { ProcessedCash } from "@/model/data/logAnalysis/ProcessedCash";
import { GetSensorsCalibrationCommand, GetSensorsCalibrationReqData } from "@/model/communication/logAnalysis/GetSensorCalibrationsCommand";
import { GetSensorsCalibrationResData } from "@/model/communication/logAnalysis/GetSensorsCalibrationResData";
import { GetCServiceLogonCommand } from "@/model/communication/logAnalysis/GetCServiceLogonCommand";
import { GetCServiceLogonResData } from "@/model/communication/logAnalysis/GetCServiceLogonResData";
import { CashTypeEnum } from "@/model/data/enums/CashTypeEnum";

import MachineExceptionCard from "./MachineExceptionCard.vue";
import SensorCalibrationCard from "./SensorCalibrationCard.vue";
import ProcessedCashCard from "./ProcessedCashCard.vue";
import RejectCard from "./RejectCard.vue";
import CServiceLogonCard from "./CServiceLogonCard.vue";

export default Vue.extend({
    components: { MachineExceptionCard, SensorCalibrationCard, ProcessedCashCard, RejectCard, CServiceLogonCard },
    props: {
        machine: Object as PropType<Machine>,
        installationName: String,
        startDateProps: {
            type: Date,
            default: null,
        },
        endDateProps: {
            type: Date,
            default: null,
        },
        hideDaysToogle: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            startDate: null,
            endDate: null,
            nDays: 15,
            rejectList: new Array<Reject>(),
            dateListString: [],
            processedCashList: new Array<ProcessedCash>(),
            seriesPCTypeList: [],
            seriesPCTrendList: [],
            machineExceptionList: new Array<MachineException>(),
            daysButton: 1,
            loading: {
                reject: true,
                pc: true,
                sc: true,
                me: true,
                csl: true,
            },
            logIntervalString: i18n.t("logAnalysis.noData"),
            CashTypeEnum,
            troubleshooting: null,
            unitLabelMap: null,
            componentLabelMap: null,
            imagesLegend: null,
            sensorCalibrationList: [],
            sensorsLabels: null,
            rejectCauseMap: null,
            rejectsFamilyMap: null,
            familyLabelMap: null,
            rejectPercentage: 0,
            cserviceLogonList: [],
        };
    },
    computed: {
        ...mapGetters(["userDateFormat"]),

        isDepositMachine() {
            if (this.machine && this.machine.model) {
                if (this.machine.model.match(/SDM (500.*|100.*|50[A-Za-z\s]+|10[A-Za-z\s]+)/g)) return true;
            }
            return false;
        },
        interventionsCount() {
            if (this.cserviceLogonList && this.cserviceLogonList.length)
                return this.cserviceLogonList.map((c) => moment(c.dateTime).format("YYYY-MM-DD")).filter((v, i, a) => a.indexOf(v) === i).length;
            return 0;
        },
    },
    watch: {
        daysButton() {
            switch (this.daysButton) {
                case 0:
                    this.nDays = 7;
                    break;
                case 1:
                    this.nDays = 15;
                    break;
                case 2:
                    this.nDays = 30;
                    break;
                default:
                    this.nDays = 15;
            }
            this.reset();
            this.getData();
        },
        machine() {
            this.reset();
            this.getData();
        },
    },
    created() {
        this.getData();
    },
    methods: {
        getData() {
            this.computeStartEndDate();
            this.getRejectData();
            this.getMachineExceptionData();
            this.getSensorsCalibration();
            this.getCServiceLogon();
        },
        reset() {
            this.startDate = null;
            this.endDate = null;
            this.rejectList = null;
            this.rejectCauseMap = null;
            this.rejectsFamilyMap = null;
            this.familyLabelMap = null;
            this.dateListString = [];
            this.processedCashList = null;
            this.seriesPCTypeList = [];
            this.seriesPCTrendList = [];
            this.machineExceptionList = null;
            this.loading = {
                reject: true,
                pc: true,
                sc: true,
                me: true,
            };
            this.logIntervalString = i18n.t("logAnalysis.noData");
            this.sensorCalibrationList = [];
            this.sensorsLabels = null;
            this.rejectPercentage = 0;
        },

        computeStartEndDate() {
            if (this.endDateProps == null) {
                this.endDate = new Date();
                this.endDate = this.subtractDays(new Date(this.endDate.getFullYear(), this.endDate.getMonth(), this.endDate.getDate()), 1);
                this.endDate = new Date(Date.UTC(this.endDate.getFullYear(), this.endDate.getMonth(), this.endDate.getDate(), 23, 59, 59));
            } else this.endDate = this.endDateProps;
            if (this.startDateProps == null) {
                this.startDate = this.subtractDays(new Date(this.endDate.getFullYear(), this.endDate.getMonth(), this.endDate.getDate()), this.nDays);
                this.startDate = new Date(Date.UTC(this.startDate.getFullYear(), this.startDate.getMonth(), this.startDate.getDate(), 0, 0, 0));
            } else this.startDate = this.startDateProps;
            if (this.startDateProps != null && this.endDateProps != null) this.nDays = Math.ceil((this.endDate.getTime() - this.startDate.getTime()) / (1000 * 3600 * 24));

            let dateList = [];
            for (let i = 0; i < this.nDays; i++) dateList.push(this.addDays(this.startDate, i));
            dateList.forEach((date) => {
                this.dateListString.push(moment(date).utc().format(this.userDateFormat));
            });
        },
        async getRejectData() {
            try {
                this.reqData = new GetMachineRejectsReqData(this.installationName, this.machine.serialNumber, this.startDate, this.endDate);
                let response: GetMachineRejectsResData = await new GetMachineRejectsCommand(this.reqData).execute();
                await this.getProcessedCashData();
                if (response.responseStatus == ApiResponseStatusEnum.Success && response.rejects && response.rejects.length > 0) {
                    this.rejectList = response.rejects;
                    this.rejectCauseMap = response.rejectsCause;
                    this.rejectsFamilyMap = response.rejectsFamily;
                    this.familyLabelMap = response.familyLabel;
                    let totalReject = this.rejectList.map((r) => r.count).reduce((accumulator, curr) => accumulator + curr);
                    let totalDepositedAndReject = this.processedCashList.map((pc) => pc.deposited).reduce((accumulator, curr) => accumulator + curr) + totalReject;
                    this.rejectPercentage = (totalReject * 100) / totalDepositedAndReject;
                }
            } catch (e) {
                console.log("Something went wrong sending GetMachineRejectsCommand request ", e);
            }
            this.loading.reject = false;
            this.loading.pc = false;
        },
        async getProcessedCashData() {
            try {
                this.reqData = new GetProcessedCashReqData(this.installationName, this.machine.serialNumber, this.startDate, this.endDate);
                let response: GetProcessedCashResData = await new GetProcessedCashCommand(this.reqData).execute();
                if (response.responseStatus == ApiResponseStatusEnum.Success && response.processedCash && response.processedCash.length > 0) {
                    this.processedCashList = response.processedCash;
                    this.logIntervalString = `${i18n.t("logAnalysis.dataAvailable")} ${i18n.t("logAnalysis.from")} ${moment(this.processedCashList[0].dateTime).format(
                        this.userDateFormat
                    )} ${i18n.t("logAnalysis.to")} ${moment(this.processedCashList[this.processedCashList.length - 1].dateTime).format(this.userDateFormat)}`;

                    let data = [0];
                    let pcTrendList = [{ name: i18n.t("logAnalysis.deposited"), data: [] }];
                    if (!this.isDepositMachine) {
                        data.push(0);
                        pcTrendList.push({ name: i18n.t("logAnalysis.withdrawn"), data: [] });
                    }

                    this.seriesPCTypeList = [{ name: this.machine.supportedCashType == 1 ? i18n.t("logAnalysis.pcBanknote") : i18n.t("logAnalysis.pcCoin"), data: data }];
                    this.seriesPCTrendList = pcTrendList;
                    this.seriesPCTrendList[0].data = new Array(this.nDays).fill(0);
                    if (this.seriesPCTrendList.length > 1) this.seriesPCTrendList[1].data = new Array(this.nDays).fill(0);
                    let dayIndex = null;
                    let initialDate = this.processedCashList[0].dateTime;
                    let finalDate = this.processedCashList[this.processedCashList.length - 1].dateTime;
                    let exceptDayList = this.dateListString.slice(
                        Math.floor((Date.UTC(initialDate.getFullYear(), initialDate.getMonth(), initialDate.getDate(), 0, 0, 0) - this.startDate.getTime()) / (1000 * 3600 * 24)),
                        Math.floor((Date.UTC(finalDate.getFullYear(), finalDate.getMonth(), finalDate.getDate(), 0, 0, 0) - this.startDate.getTime()) / (1000 * 3600 * 24) + 1)
                    );
                    this.processedCashList.forEach((pc) => {
                        this.seriesPCTypeList[0].data[0] += pc.deposited;
                        if (!this.isDepositMachine) this.seriesPCTypeList[0].data[1] += pc.withdrawn;
                        let utcDate = Date.UTC(pc.dateTime.getFullYear(), pc.dateTime.getMonth(), pc.dateTime.getDate(), 0, 0, 0);
                        dayIndex = Math.floor((utcDate - this.startDate.getTime()) / (1000 * 3600 * 24));
                        this.seriesPCTrendList[0].data[dayIndex] = pc.deposited;
                        if (!this.isDepositMachine) this.seriesPCTrendList[1].data[dayIndex] = pc.withdrawn;
                        delete exceptDayList[
                            Math.floor((utcDate - Date.UTC(initialDate.getFullYear(), initialDate.getMonth(), initialDate.getDate(), 0, 0, 0)) / (1000 * 3600 * 24))
                        ];
                    });
                    if (exceptDayList && exceptDayList.filter((a) => a).length) {
                        this.logIntervalString += `\n ${i18n.t("logAnalysis.dataMissing")}`;
                        exceptDayList.forEach((date) => {
                            this.logIntervalString += ` ${date},`;
                        });
                        this.logIntervalString = this.logIntervalString.slice(0, -1);
                    }
                }
            } catch (e) {
                console.log("Something went wrong sending GetProcessedCashCommand request ", e);
            }
            this.loading.pc = false;
        },
        async getMachineExceptionData() {
            try {
                this.reqData = new GetMachineExceptionsReqData(this.installationName, this.machine.serialNumber, this.startDate, this.endDate);
                let response: GetMachineExceptionsResData = await new GetMachineExceptionsCommand(this.reqData).execute();

                if (response.responseStatus == ApiResponseStatusEnum.Success && response.machineExceptions && response.machineExceptions.length > 0) {
                    this.machineExceptionList = response.machineExceptions;
                    this.troubleshooting = response.troubleshooting;
                    this.componentLabelMap = response.componentLabelMap;
                    this.unitLabelMap = response.unitLabelMap;
                    this.imagesLegend = response.imagesLegend;
                }
            } catch (e) {
                console.log("Something went wrong sending GetMachineExceptionsCommand request ", e);
            }
            this.loading.me = false;
        },
        async getSensorsCalibration() {
            try {
                this.reqData = new GetSensorsCalibrationReqData(this.installationName, this.machine.serialNumber, this.startDate, this.endDate);
                let response: GetSensorsCalibrationResData = await new GetSensorsCalibrationCommand(this.reqData).execute();

                if (response.responseStatus == ApiResponseStatusEnum.Success && response.sensorCalibration && response.sensorCalibration.length > 0) {
                    this.sensorCalibrationList = response.sensorCalibration;
                    this.sensorsLabels = response.sensorsLabels;
                }
            } catch (e) {
                console.log("Something went wrong sending GetSensorsCalibrationCommand request ", e);
            }
            this.loading.sc = false;
        },
        async getCServiceLogon() {
            try {
                let response: GetCServiceLogonResData = await new GetCServiceLogonCommand(this.installationName, this.machine.serialNumber, this.startDate, this.endDate).execute();

                if (response.responseStatus == ApiResponseStatusEnum.Success && response.cserviceLogon && response.cserviceLogon.length > 0) {
                    this.cserviceLogonList = response.cserviceLogon;
                }
            } catch (e) {
                console.log("Something went wrong sending GetSensorsCalibrationCommand request ", e);
            }
            this.loading.csl = false;
        },
        addDays(date: Date, days: number) {
            let newDate = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds()));
            newDate.setUTCDate(date.getDate() + days);
            return newDate;
        },
        subtractDays(date: Date, days: number) {
            let newDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
            newDate.setUTCDate(date.getDate() - days);
            return newDate;
        },
        setRowStyle() {
            return "style-1";
        },
    },
});
